import { useNavigate } from 'react-router-dom'
import { ShieldX, ArrowLeft } from 'lucide-react'

/**
 * 403 Forbidden page — shown when a user tries to access a route
 * they don't have permission for.
 */
export function ForbiddenPage() {
  const navigate = useNavigate()

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center">
        <div className="flex justify-center mb-4">
          <ShieldX size={64} className="text-gray-300" />
        </div>
        <h1 className="text-6xl font-bold text-gray-300 mb-4">403</h1>
        <h2 className="text-xl font-semibold text-gray-700 mb-2">
          Acceso denegado
        </h2>
        <p className="text-gray-500 mb-6">
          No tienes permisos para ver esta página.
        </p>
        <button
          onClick={() => navigate(-1)}
          className="btn btn-primary inline-flex items-center gap-1.5"
        >
          <ArrowLeft size={16} />
          Volver
        </button>
      </div>
    </div>
  )
}
